export const i18n = {
  zh: {
    platformname: "Withflows",
    slogon: "让运营更智能",
    welcome: "欢迎回来，张经理",
    today: "今天是 {date}，祝您工作愉快！",
    dashboard: "首页",
    streamer_manage: "主播管理",
    add_streamer: "添加主播",
    search: "搜索",
    status: "状态",
    level: "等级",
    fans: "粉丝数",
    income: "本月收入",
    live_hours: "直播时长",
    actions: "操作",
    edit: "编辑",
    data: "数据",
    more: "更多",
    online: "在线",
    offline: "离线",
    all: "全部",
    active: "活跃",
    inactive: "未活跃",
    streamer_unit: "位主播",
    active_streamers: "活跃主播",
    income_today: "今日收入",
    live_sessions: "直播场次",
    new_fans: "新增粉丝",
    ai_recommend: "AI智能推荐",
    ai_recommend_desc: "AI自动分析数据，推送运营建议与风险预警",
    view_recommend: "查看推荐",
    ai_schedule: "智能排期",
    ai_schedule_desc: "AI根据主播表现和观众偏好，智能生成直播/活动排期",
    schedule_now: "立即排期",
    one_click_publish: "一键分发",
    one_click_publish_desc: "支持多平台内容一键分发，自动适配平台要求",
    go_publish: "去分发",
    streamer_manage_desc: "管理主播信息、合同、绩效等核心数据",
    live_manage: "直播管理",
    live_manage_desc: "监控直播数据、互动情况、礼物统计等",
    live_unit: "场直播中",
    content_ops: "内容运营",
    content_ops_desc: "内容规划、活动策划、粉丝互动等",
    activity_unit: "个活动进行中",
    finance_manage: "财务管理",
    finance_manage_desc: "收入统计、支出管理、分成结算等",
    this_month_income: "本月收入",
    ai_assistant: "智能助手",
    ai_assistant_desc: "AI运营建议、数据预测、智能排期等",
    new_suggestion: "条新建议",
    data_analytics: "数据分析",
    data_analytics_desc: "深度数据分析、趋势预测、报表导出等",
    new_report: "份新报告",
    ai_helper: "AI助手",
    streamer_agent: "主播工作台",
    operation_agent: "运营经纪人工作台",
    publish_agent: "视频发布工作台",
    add_task: "添加任务",
    task_list: "任务列表",
    performance: "绩效概览",
    schedule: "排班表",
    notice: "公告",
    role_connect_agent: "建联经纪人",
    role_streamer_agent: "主播",
    role_operation_agent: "运营经纪人",
    role_publish_agent: "视频发布",
    save: "保存",
    cancel: "取消",
    search_placeholder: "输入关键词...",
    connect_agent: "建联工作台",
    account_assign: "账号分配",
    add_account: "新建账号",
    account_assign_desc: "分配各平台账号，支持批量导入与AI智能分配",
    ai_assign: "AI智能分配",
    clue_pool: "线索池/流转",
    clue_flow: "线索流转",
    clue_desc: "管理线索池，支持AI线索优先级排序与流转建议",
    ai_clue: "AI线索分析",
    contact: "沟通与联系",
    add_contact: "新建沟通",
    contact_desc: "与主播/客户沟通，AI自动生成沟通话术与记录",
    ai_contact: "AI话术推荐",
    convert: "转化与签约",
    add_contract: "新建签约",
    convert_desc: "转化跟进，AI预测转化率与签约建议",
    ai_convert: "AI转化预测",
    all_status: "所有状态",
    status_live: "直播中",
    status_rest: "休息中",
    status_pending: "待审核",
    // StreamerAgent页面相关
    prepare: "开播准备",
    add_prepare: "添加准备",
    prepare_desc: "管理直播前的准备工作，包括设备检查、内容准备、时间安排等",
    ai_prepare: "AI智能准备",
    device_purchase: "设备/软件采购",
    add_device: "添加设备",
    device_desc: "管理直播设备和软件采购，包括摄像头、麦克风、直播软件等",
    ai_device: "AI设备推荐",
    test: "开播测试/试播",
    start_test: "开始测试",
    test_desc: "进行直播测试和试播，确保设备和内容正常运行",
    ai_test: "AI测试建议",
    start: "正式开播",
    go_live: "开始直播",
    start_desc: "正式开启直播，管理直播过程中的各项事务",
    ai_live: "AI直播助手",
    // OperationAgent页面相关
    train: "培训/测评/辅导",
    add_train: "添加培训",
    train_desc: "主播培训和技能提升，包括直播技巧、内容创作、粉丝互动等",
    ai_train: "AI培训建议",
    report: "数据报告/分析/复盘",
    add_report: "添加报告",
    report_desc: "数据分析和报告生成，包括直播数据、粉丝增长、收入统计等",
    ai_report: "AI报告生成",
    income_calc: "收益计算",
    calc_income: "计算收益",
    income_desc: "收益计算和财务管理，包括收入统计、支出管理、分成结算等",
    ai_income: "AI收益预测",
    customer_binding: "客户绑定/解绑管理",
    // PublishAgent页面相关
    material: "素材库/模板/设计",
    add_material: "添加素材",
    material_desc: "管理视频素材和模板，包括图片、视频、音频等素材资源",
    ai_material: "AI素材推荐",
    clip: "分割短片/字幕/翻译",
    add_clip: "添加剪辑",
    clip_desc: "视频剪辑和字幕处理，包括视频分割、字幕添加、多语言翻译等",
    ai_clip: "AI智能剪辑",
    publish: "多平台发布",
    add_publish: "添加发布",
    publish_desc: "多平台内容发布管理，支持一键分发到多个平台",
    ai_publish: "AI发布优化",
    // HeadAgent页面相关
    head_agent: "Head-Agent 智能体",
    head_agent_desc: "中央协调器 - 意图识别、目标拆解、Agent分发、结果处理",
    running: "运行中",
    config: "配置",
    workflow_status: "工作流程状态",
    intent_recognition: "意图识别",
    intent_recognition_desc: "理解用户需求",
    active_status: "活跃",
    processing_requests: "处理中",
    goal_decomposition: "目标拆解",
    goal_decomposition_desc: "分解复杂任务",
    decomposed_goals: "已拆解",
    agent_decomposition: "Agent分解",
    agent_decomposition_desc: "分配专业智能体",
    assigned_tasks: "已分配",
    agent_distribution: "Agent分发",
    agent_distribution_desc: "任务分发执行",
    distributed_tasks: "已分发",
    result_processing: "结果处理",
    result_processing_desc: "汇总处理结果",
    processed_results: "已处理",
    input_monitoring: "输入源监控",
    anchor_elf_input: "主播精灵输入",
    dialogue_request: "对话请求",
    observation_data: "观察数据",
    suggestion_generation: "建议生成",
    pan_entertainment_input: "泛娱乐插件智能体输入",
    speech_generation: "话术生成",
    data_analysis: "数据分析",
    auto_follow: "自动跟播",
    output_monitoring: "输出目标监控",
    frontend_output: "前端平台输出",
    backend_output: "后端服务输出",
    data_storage: "数据存储",
    api_call: "API调用",
    log_record: "日志记录",
    success: "成功",
    real_time_monitoring: "实时监控面板",
    today_requests: "今日处理请求",
    success_rate: "成功率",
    avg_response_time: "平均响应时间",
    active_agents: "活跃Agent",
    // TotalFlow页面相关
    total_flow: "总智能流",
    total_flow_desc: "智能体工作流程总览 - Head-Agent 协调各专业智能体",
    smart_flow_running: "智能流运行中",
    flow_config: "流程配置",
    head_agent_coordinator: "Head-Agent 中央协调器",
    smart_coordinating: "智能协调中",
    understand_demand: "理解用户需求",
    decompose_tasks: "分解复杂任务",
    assign_agents: "分配专业智能体",
    distribute_tasks: "任务分发执行",
    process_results: "汇总处理结果",
    professional_agents: "专业智能体工作流",
    recruiting_agent: "Recruiting-Agent 招聘代理",
    creator_agent: "Creator-Agent 创作者代理",
    video_producer_agent: "VideoProducer-Agent 视频制作代理",
    lead_collection: "线索收集",
    lead_collection_desc: "自动收集潜在创作者信息",
    analysis: "分析",
    analysis_desc: "智能分析创作者潜力",
    connection: "建联",
    connection_desc: "建立初步联系沟通",
    recruitment_cooperation: "招聘合作",
    recruitment_cooperation_desc: "达成合作意向",
    pre_broadcast_training: "开播前受训",
    pre_broadcast_training_desc: "专业培训提升技能",
    live_script: "直播话术",
    live_script_desc: "智能生成直播脚本",
    highlight_moments: "高光时刻",
    highlight_moments_desc: "自动识别精彩片段",
    review_improvement: "复盘改进",
    review_improvement_desc: "数据分析优化建议",
    revenue_summary: "收益汇总",
    revenue_summary_desc: "收入统计与分析",
    pre_broadcast_prep: "开播前准备",
    pre_broadcast_prep_desc: "设备检查与场景布置",
    creator_training: "创作者培训",
    creator_training_desc: "专业技能培训指导",
    auto_follow_broadcast: "自动跟播",
    auto_follow_broadcast_desc: "智能跟播热门话题",
    review: "复盘",
    review_desc: "深度数据分析",
    revenue_analysis: "收益分析",
    revenue_analysis_desc: "收入趋势与预测",
    material_management: "素材管理",
    material_management_desc: "智能素材分类整理",
    content_theme: "内容主题",
    content_theme_desc: "AI生成内容主题",
    auto_editing: "自动剪辑",
    auto_editing_desc: "智能视频剪辑",
    auto_generation: "自动生成",
    auto_generation_desc: "AI生成视频内容",
    platform_distribution: "平台分发",
    platform_distribution_desc: "多平台智能分发",
    result_analysis: "结果分析",
    result_analysis_desc: "分发效果分析",
    video_revenue_analysis: "视频收益统计",
    smart_flow_status: "智能流状态监控",
    communication_protocol: "通信协议",
    mcp_protocol: "MCP协议",
    http_interface: "HTTP接口",
    real_time_communication: "实时通信",
    // StreamerWorkbench页面相关
    streamer_workbench: "主播工作台",
    streamer_workbench_desc: "专业主播培训、直播话术、高光时刻管理",
    streamer_workbench_running: "主播工作台运行中",
    new_streamer: "新建主播",
    total_streamers: "总主播数",
    online_streamers: "在线主播",
    online_rate: "在线率",
    today_training: "今日培训",
    completion_rate: "完成率",
    highlight_moments_count: "高光时刻",
    pre_broadcast_training_title: "开播前受训",
    basic_skill_training: "基础技能培训",
    basic_skill_desc: "摄像头操作、灯光调节、声音设置",
    script_training: "话术训练",
    script_training_desc: "开场白、互动技巧、结束语",
    platform_rules: "平台规则学习",
    platform_rules_desc: "各平台直播规范、违规行为",
    live_script_title: "直播话术",
    new_script: "新建话术",
    opening_script: "开场话术",
    opening_script_text: "大家好，欢迎来到我的直播间...",
    interaction_script: "互动话术",
    interaction_script_text: "感谢大家的礼物，谢谢支持...",
    ending_script: "结束话术",
    ending_script_text: "今天的直播就到这里，明天见...",
    usage_count: "使用次数",
    highlight_moments_title: "高光时刻",
    ai_recognition: "AI识别",
    wonderful_interaction: "精彩互动",
    wonderful_interaction_desc: "与粉丝的精彩互动片段",
    talent_show: "才艺展示",
    talent_show_desc: "主播才艺表演精彩片段",
    funny_moment: "搞笑瞬间",
    funny_moment_desc: "直播中的搞笑有趣瞬间",
    duration: "时长",
    streamer_management: "主播管理",
    search_streamer: "搜索主播...",
    streamer_status: "状态",
    training_progress: "培训进度",
    highlight_count: "高光时刻",
    online_live: "在线直播",
    training_in_progress: "培训中",
    view: "查看",
    // OperationWorkbench页面相关
    operation_workbench: "运营工作台",
    operation_workbench_desc: "运营管理、培训指导、数据分析、收益优化",
    operation_workbench_running: "运营工作台运行中",
    new_operation_task: "新建运营任务",
    operation_tasks: "运营任务",
    training_completed: "培训完成",
    auto_follow_count: "自动跟播",
    ai_driven: "AI驱动",
    revenue_growth: "收益增长",
    this_month: "本月",
    pre_broadcast_prep_title: "开播前准备",
    device_check: "设备检查",
    device_check_desc: "摄像头、麦克风、网络连接检查",
    scene_setup: "场景布置",
    scene_setup_desc: "背景设置、灯光调节、道具准备",
    content_planning: "内容规划",
    content_planning_desc: "直播主题、互动环节、时间安排",
    creator_training_title: "创作者培训",
    new_training: "新建培训",
    skill_training: "技能培训",
    skill_training_desc: "直播技巧、互动方法、话术训练",
    platform_rules_training: "平台规则",
    platform_rules_training_desc: "各平台规范、违规行为、最佳实践",
    data_analysis_training: "数据分析",
    data_analysis_training_desc: "数据解读、趋势分析、优化建议",
    participants: "参与人数",
    completed_count: "完成人数",
    auto_follow_title: "自动跟播",
    hot_topics: "热门话题",
    hot_topics_desc: "实时监控热门话题，自动生成内容",
    competitor_analysis: "竞品分析",
    competitor_analysis_desc: "监控竞品动态，分析成功策略",
    content_recommendation: "内容推荐",
    content_recommendation_desc: "基于算法推荐相关内容",
    tracking_topics: "跟踪话题",
    analysis_objects: "分析对象",
    recommended_content: "推荐内容",
    review_analysis_title: "复盘分析",
    deep_analysis: "深度分析",
    data_review: "数据复盘",
    data_review_desc: "观看数据、互动数据、收益分析",
    problem_identification: "问题识别",
    problem_identification_desc: "识别直播中的问题和改进点",
    optimization_suggestions: "优化建议",
    optimization_suggestions_desc: "基于分析生成优化建议",
    analysis_sessions: "分析场次",
    problems_found: "发现问题",
    suggestions_count: "建议数量",
    operation_task_management: "运营任务管理",
    //all_status: "全部状态",
    in_progress: "进行中",
    completed: "已完成",
    pending: "待开始",
    filter: "筛选",
    task_name: "任务名称",
    task_type: "类型",
    task_status: "状态",
    progress: "进度",
    training_task: "培训任务",
    follow_task: "跟播任务",
    new_streamer_training: "新主播培训计划",
    new_streamer_training_desc: "培训新加入的主播",
    hot_topic_follow: "热门话题跟播",
    hot_topic_follow_desc: "跟踪热门话题并制作内容",
    //start: "开始",
    // VideoWorkbench页面相关
    video_workbench: "视频工作台",
    video_workbench_desc: "智能视频制作、自动剪辑、多平台分发",
    video_workbench_running: "视频工作台运行中",
    new_video_project: "新建视频项目",
    material_library: "素材库",
    auto_editing_count: "自动剪辑",
    platform_distribution_count: "平台分发",
    multi_platform: "多平台",
    play_count: "播放量",
    this_week: "本周",
    material_management_title: "素材管理",
    upload_material: "上传素材",
    live_recording: "直播录屏",
    live_recording_desc: "今日直播精彩片段素材",
    background_music: "背景音乐",
    background_music_desc: "版权音乐库、音效素材",
    effect_templates: "特效模板",
    effect_templates_desc: "转场效果、滤镜、动画",
    file_count: "文件数",
    content_theme_title: "内容主题",
    hot_topic_theme: "热门话题",
    hot_topic_theme_desc: "基于热搜生成的内容主题",
    emotional_resonance: "情感共鸣",
    emotional_resonance_desc: "引发情感共鸣的内容主题",
    knowledge_sharing: "知识分享",
    knowledge_sharing_desc: "教育类、技能分享主题",
    heat: "热度",
    resonance_degree: "共鸣度",
    educational_value: "教育价值",
    auto_editing_title: "自动剪辑",
    smart_segmentation: "智能分段",
    smart_segmentation_desc: "AI自动识别精彩片段并分段",
    auto_music: "自动配乐",
    auto_music_desc: "根据内容自动匹配背景音乐",
    effect_addition: "特效添加",
    effect_addition_desc: "自动添加转场、滤镜、字幕",
    processing: "处理中",
    completed_videos: "完成",
    queue: "队列",
    auto_generation_title: "自动生成",
    ai_creation: "AI创作",
    title_generation: "标题生成",
    title_generation_desc: "AI生成吸引人的视频标题",
    subtitle_generation: "字幕生成",
    subtitle_generation_desc: "语音识别自动生成字幕",
    cover_generation: "封面生成",
    cover_generation_desc: "AI生成视频封面图片",
    generating: "生成中",
    platform_distribution_title: "平台分发",
    new_distribution_task: "新建分发任务",
    douyin: "抖音",
    kuaishou: "快手",
    video_account: "视频号",
    short_video_distribution: "短视频平台分发",
    wechat_video_distribution: "微信视频号分发",
    result_analysis_title: "结果分析",
    generate_report: "生成报告",
    last_7_days: "最近7天",
    last_30_days: "最近30天",
    last_90_days: "最近90天",
    total_play_count: "总播放量",
    new_fans_count: "新增粉丝",
    //completion_rate: "完播率",
    revenue_analysis_amount: "收益分析",
    // 通用词汇
    requests: "个请求",
    goals: "个目标",
    tasks: "个任务",
    results: "个结果",
    //status: "状态",
    //active_status: "活跃",
    //processing_requests: "处理中",
    //decomposed_goals: "已拆解",
    //assigned_tasks: "已分配",
    //distributed_tasks: "已分发",
    //processed_results: "已处理"
    // CreatorLead页面相关
    creator_lead_dashboard: "创作者线索仪表盘",
    new_leads_added: "新增线索",
    added_to_talent_pool: "已添加到人才库，继续努力！",
    leads: "线索",
    rising: "上升中",
    affiliated: "已关联",
    eliminated: "已淘汰",
    live_creator: "直播创作者",
    videos: "视频",
    followers: "粉丝",
    likes: "点赞",
    view_details: "查看详情",
    
    // CreatorDetail页面相关
    lead_added_on: "线索添加时间：",
    live_stream_data: "直播数据",
    live_duration: "直播时长",
    live_session_id: "直播场次",
    total_comments: "总评论",
    unique_commenters: "评论者人数",
    live_viewers: "直播观众",
    gift_count: "礼物数量",
    gift_value: "礼物价值",
    performance_trend: "绩效趋势",
    // 线索管理页面
    clue_management: "线索池管理",
    clue_management_desc: "管理创作者线索，支持状态变更和筛选查询",
    status_filter: "状态筛选",
    start_date: "开始日期",
    end_date: "结束日期",
    total_leads: "总线索",
    pending_leads: "待处理",
    contracting_leads: "预跟踪",
    signed_leads: "已签约",
    eliminated_leads: "已淘汰",
    lead_list: "线索列表",
    social_account: "社交账号",
    create_time: "创建时间",
    change_status: "变更状态",
    view_detail: "查看详情",
    change_lead_status: "变更线索状态",
    lead_id: "线索ID",
    new_status: "新状态",
    confirm_update: "确认更新",
    updating: "更新中...",
    status_update_success: "状态更新成功",
    status_update_failed: "状态更新失败，请重试",
    loading_data: "加载中...",
    load_failed: "加载数据失败，请重试",
    retry: "重试",
    showing_records: "显示第",
    to: "到",
    of: "条，共",
    records: "条记录",
    previous_page: "上一页",
    next_page: "下一页",
    follow_priority: "跟播优先级",
    change_priority: "修改优先级",
    change_lead_priority: "修改线索优先级",
    new_priority: "新优先级",
    priority_update_success: "优先级更新成功",
    priority_update_failed: "优先级更新失败，请重试",

    // AgentChat页面相关
    agent_chat: "智能体问答",
    agent_chat_desc: "与智能体进行实时对话，获取专业建议和解决方案",
    agent_online: "智能体在线",
    clear_chat: "清空对话",
    available_agents: "可用智能体",
    select_agent: "请选择智能体",
    select_agent_desc: "选择一个智能体开始对话",
    welcome_message: "欢迎使用智能体问答系统",
    welcome_desc: "选择一个智能体，开始您的智能对话之旅",
    type_message: "输入您的问题...",
    send: "发送",
    
    // 招聘智能体页面相关
    recruitment_agent: "招聘智能体",
    recruitment_agent_desc: "智能招聘管理系统，内嵌外部招聘系统",
    system_online: "系统在线",
    refresh: "刷新",
    total_candidates: "总候选人",
    active_candidates: "活跃候选人",
    pending_reviews: "待审核",
    recruitment_success_rate: "成功率",
    recruitment_system: "招聘系统",
    open_in_new_tab: "新窗口打开",
    loading_system: "系统加载中...",
    
    // 创作者视频相关
    creator_videos: "创作者视频",
    total_videos: "总视频数",
    total_views: "总播放量",
    loading_videos: "加载视频中...",
    click_video_to_watch: "点击视频观看",
    
    // 菜单名称
    menu_head_agent: "总智能体",
    menu_head_flow: "总智能流",
    menu_agent_chat: "智能体问答",
    menu_recruitment_agent: "招聘智能体",
    menu_recruitment_management: "招聘管理",
    menu_external_system: "外部系统",
    menu_connect_agent: "建联智能体",
    menu_connect_workbench: "建联工作台",
    menu_connect_flow: "建联标准流",
    menu_streamer_agent: "主播智能体",
    menu_streamer_workbench: "主播工作台",
    menu_streamer_flow: "主播标准流",
    menu_operation_agent: "运营智能体",
    menu_operation_workbench: "运营工作台",
    menu_operation_flow: "运营标准流",
    menu_publish_agent: "发布智能体",
    menu_publish_workbench: "发布工作台",
    menu_publish_flow: "发布标准流",
    
    // 页脚相关
    footer_description: "泛娱乐直播智能工作台，为直播行业提供全方位的智能化解决方案",
    footer_products: "产品服务",
    footer_smart_live_assistant: "智能直播助手",
    footer_data_analysis: "数据分析平台",
    footer_content_management: "内容管理系统",
    footer_fan_interaction: "粉丝互动工具",
    footer_contact: "联系我们",
    footer_phone: "400-888-8888",
    footer_email: "contact@withflows.ai",
    footer_address: "上海市徐汇区乐山路33号慧谷创业园2号楼201E",
    footer_copyright: "© 2025 Withflows. All rights reserved.",
    footer_privacy: "隐私政策",
    footer_terms: "服务条款",
    
    // 招聘简历相关
    resume_list: "简历列表",
    resume_id: "简历ID",
    candidate_name: "候选人姓名",
    position: "应聘职位",
    experience: "工作经验",
    submit_time: "提交时间",
    pending_screening: "待筛选",
    interview: "进入面试",
    rejected_status: "拒绝",
    hired_status: "录用",
    resume_search_placeholder: "搜索候选人姓名或职位",
    update_resume_status: "更新简历状态",
    resume_new_status: "新状态",
    resume_view: "查看",
    resume_file: "简历文件",
    download: "下载",
    no_file: "无文件",
    years: "年",
    
    // 高光时刻相关
    session_id: "会话ID",
    total_highlights: "总高光数",
    sort_by: "排序方式",
    highlight_create_time: "创建时间",
    highlight_score: "高光评分",
    confidence_score: "置信度",
    highlight_duration: "时长",
    sort_order: "排序顺序",
    descending: "降序",
    ascending: "升序",
    highlight_list: "高光列表",
    confidence: "置信度",
    file_size: "文件大小",
    back: "返回",
    view_highlights: "查看高光",
    video_not_supported: "视频格式不支持"
  },
  en: {
    platformname: "Withflows",
    slogon: "Make Operations Smarter",
    welcome: "Welcome back, Manager Zhang",
    today: "Today is {date}, have a great day!",
    dashboard: "Dashboard",
    streamer_manage: "Streamer Management",
    add_streamer: "Add Streamer",
    search: "Search",
    status: "Status",
    level: "Level",
    fans: "Fans",
    income: "Monthly Income",
    live_hours: "Live Hours",
    actions: "Actions",
    edit: "Edit",
    data: "Data",
    more: "More",
    online: "Online",
    offline: "Offline",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    streamer_unit: "streamers",
    active_streamers: "Active Streamers",
    income_today: "Today's Income",
    live_sessions: "Live Sessions",
    new_fans: "New Fans",
    ai_recommend: "AI Smart Recommendations",
    ai_recommend_desc: "AI automatically analyzes data and pushes operational suggestions and risk warnings",
    view_recommend: "View Recommendations",
    ai_schedule: "Smart Scheduling",
    ai_schedule_desc: "AI generates live/activity schedules based on streamer performance and audience preferences",
    schedule_now: "Schedule Now",
    one_click_publish: "One-Click Distribution",
    one_click_publish_desc: "Support one-click content distribution across multiple platforms with automatic platform adaptation",
    go_publish: "Go Publish",
    streamer_manage_desc: "Manage streamer information, contracts, performance and other core data",
    live_manage: "Live Management",
    live_manage_desc: "Monitor live data, interactions, gift statistics, etc.",
    live_unit: "live sessions",
    content_ops: "Content Operations",
    content_ops_desc: "Content planning, activity planning, fan interaction, etc.",
    activity_unit: "activities in progress",
    finance_manage: "Financial Management",
    finance_manage_desc: "Income statistics, expense management, profit sharing settlement, etc.",
    this_month_income: "This Month's Income",
    ai_assistant: "AI Assistant",
    ai_assistant_desc: "AI operational suggestions, data prediction, smart scheduling, etc.",
    new_suggestion: "new suggestions",
    data_analytics: "Data Analytics",
    data_analytics_desc: "Deep data analysis, trend prediction, report export, etc.",
    new_report: "new reports",
    ai_helper: "AI Helper",
    streamer_agent: "Streamer Workbench",
    operation_agent: "Operation Agent Workbench",
    publish_agent: "Video Publisher Workbench",
    add_task: "Add Task",
    task_list: "Task List",
    performance: "Performance Overview",
    schedule: "Schedule",
    notice: "Notice",
    role_connect_agent: "Connection Agent",
    role_streamer_agent: "Streamer",
    role_operation_agent: "Operation Agent",
    role_publish_agent: "Video Publisher",
    save: "Save",
    cancel: "Cancel",
    search_placeholder: "Enter keywords...",
    connect_agent: "Connection Agent",
    account_assign: "Account Assignment",
    add_account: "New Account",
    account_assign_desc: "Assign platform accounts with batch import and AI smart assignment support",
    ai_assign: "AI Smart Assignment",
    clue_pool: "Lead Pool/Flow",
    clue_flow: "Lead Flow",
    clue_desc: "Manage lead pool with AI lead priority sorting and flow suggestions",
    ai_clue: "AI Lead Analysis",
    contact: "Communication & Contact",
    add_contact: "New Communication",
    contact_desc: "Communicate with streamers/clients with AI auto-generated scripts and records",
    ai_contact: "AI Script Recommendations",
    convert: "Conversion & Contract",
    add_contract: "New Contract",
    convert_desc: "Conversion follow-up with AI conversion rate prediction and contract suggestions",
    ai_convert: "AI Conversion Prediction",
    all_status: "All Status",
    status_live: "Live",
    status_rest: "Rest",
    status_pending: "Pending",
    // StreamerAgent page related
    prepare: "Live Preparation",
    add_prepare: "Add Preparation",
    prepare_desc: "Manage pre-live preparations including equipment checks, content preparation, and scheduling",
    ai_prepare: "AI Smart Preparation",
    device_purchase: "Device/Software Purchase",
    add_device: "Add Device",
    device_desc: "Manage live streaming equipment and software purchases including cameras, microphones, and streaming software",
    ai_device: "AI Device Recommendations",
    test: "Live Test/Trial",
    start_test: "Start Test",
    test_desc: "Conduct live streaming tests and trials to ensure equipment and content work properly",
    ai_test: "AI Test Suggestions",
    start: "Go Live",
    go_live: "Start Live",
    start_desc: "Officially start live streaming and manage various aspects during the live session",
    ai_live: "AI Live Assistant",
    // OperationAgent page related
    train: "Training/Assessment/Coaching",
    add_train: "Add Training",
    train_desc: "Streamer training and skill enhancement including live streaming techniques, content creation, and fan interaction",
    ai_train: "AI Training Suggestions",
    report: "Data Reports/Analysis/Review",
    add_report: "Add Report",
    report_desc: "Data analysis and report generation including live data, fan growth, and income statistics",
    ai_report: "AI Report Generation",
    income_calc: "Income Calculation",
    calc_income: "Calculate Income",
    income_desc: "Income calculation and financial management including income statistics, expense management, and profit sharing settlement",
    ai_income: "AI Income Prediction",
    customer_binding: "Customer Binding Management",
    // PublishAgent page related
    material: "Material Library/Templates/Design",
    add_material: "Add Material",
    material_desc: "Manage video materials and templates including images, videos, audio and other material resources",
    ai_material: "AI Material Recommendations",
    clip: "Video Clips/Subtitles/Translation",
    add_clip: "Add Clip",
    clip_desc: "Video editing and subtitle processing including video segmentation, subtitle addition, and multi-language translation",
    ai_clip: "AI Smart Editing",
    publish: "Multi-Platform Publishing",
    add_publish: "Add Publishing",
    publish_desc: "Multi-platform content publishing management supporting one-click distribution to multiple platforms",
    ai_publish: "AI Publishing Optimization",
    // HeadAgent page related
    head_agent: "Head-Agent Intelligent Agent",
    head_agent_desc: "Central Coordinator - Intent Recognition, Goal Decomposition, Agent Distribution, Result Processing",
    running: "Running",
    config: "Configuration",
    workflow_status: "Workflow Status",
    intent_recognition: "Intent Recognition",
    intent_recognition_desc: "Understanding User Needs",
    active_status: "Active",
    processing_requests: "Processing",
    goal_decomposition: "Goal Decomposition",
    goal_decomposition_desc: "Decomposing Complex Tasks",
    decomposed_goals: "Decomposed",
    agent_decomposition: "Agent Decomposition",
    agent_decomposition_desc: "Assigning Professional Intelligent Agents",
    assigned_tasks: "Assigned",
    agent_distribution: "Agent Distribution",
    agent_distribution_desc: "Task Distribution Execution",
    distributed_tasks: "Distributed",
    result_processing: "Result Processing",
    result_processing_desc: "Summarizing Results",
    processed_results: "Processed",
    input_monitoring: "Input Source Monitoring",
    anchor_elf_input: "Anchor Elf Input",
    dialogue_request: "Dialogue Request",
    observation_data: "Observation Data",
    suggestion_generation: "Suggestion Generation",
    pan_entertainment_input: "Pan Entertainment Plugin Intelligent Agent Input",
    speech_generation: "Script Generation",
    data_analysis: "Data Analysis",
    auto_follow: "Auto-Follow",
    output_monitoring: "Output Target Monitoring",
    frontend_output: "Frontend Platform Output",
    backend_output: "Backend Service Output",
    data_storage: "Data Storage",
    api_call: "API Call",
    log_record: "Log Record",
    success: "Success",
    real_time_monitoring: "Real-Time Monitoring Panel",
    today_requests: "Today's Requests",
    success_rate: "Success Rate",
    avg_response_time: "Average Response Time",
    active_agents: "Active Agents",
    // TotalFlow page related
    total_flow: "Total Intelligent Flow",
    total_flow_desc: "Total Overview of Intelligent Agent Workflow - Head-Agent Coordinates Various Professional Intelligent Agents",
    smart_flow_running: "Smart Flow Running",
    flow_config: "Flow Configuration",
    head_agent_coordinator: "Head-Agent Central Coordinator",
    smart_coordinating: "Smart Coordination",
    understand_demand: "Understanding User Needs",
    decompose_tasks: "Decomposing Complex Tasks",
    assign_agents: "Assigning Professional Intelligent Agents",
    distribute_tasks: "Task Distribution Execution",
    process_results: "Summarizing Results",
    professional_agents: "Professional Intelligent Agent Workflow",
    recruiting_agent: "Recruiting-Agent Recruitment Agent",
    creator_agent: "Creator-Agent Creator Agent",
    //operation_agent: "Operation-Agent Operation Agent",
    video_producer_agent: "VideoProducer-Agent Video Production Agent",
    lead_collection: "Lead Collection",
    lead_collection_desc: "Automatically collecting potential creator information",
    analysis: "Analysis",
    analysis_desc: "Intelligent Analysis of Creator Potential",
    connection: "Connection",
    connection_desc: "Establishing Initial Contact Communication",
    recruitment_cooperation: "Recruitment Cooperation",
    recruitment_cooperation_desc: "Reaching Cooperation Intentions",
    pre_broadcast_training: "Pre-Broadcast Training",
    pre_broadcast_training_desc: "Professional Training to Enhance Skills",
    live_script: "Live Script",
    live_script_desc: "Intelligent Script Generation for Live Broadcast",
    highlight_moments: "Highlight Moments",
    highlight_moments_desc: "Automatically Identifying Exciting Moments",
    review_improvement: "Review and Improvement",
    review_improvement_desc: "Data Analysis Optimization Suggestions",
    revenue_summary: "Revenue Summary",
    revenue_summary_desc: "Income Statistics and Analysis",
    pre_broadcast_prep: "Pre-Broadcast Preparation",
    pre_broadcast_prep_desc: "Equipment Check and Scene Setup",
    creator_training: "Creator Training",
    creator_training_desc: "Professional Skill Training Guidance",
    auto_follow_broadcast: "Auto-Follow Broadcast",
    auto_follow_broadcast_desc: "Smartly Following Hot Topics",
    review: "Review",
    review_desc: "Deep Data Analysis",
    revenue_analysis: "Revenue Analysis",
    revenue_analysis_desc: "Income Trend and Prediction",
    material_management: "Material Management",
    material_management_desc: "Intelligent Material Classification and Organization",
    content_theme: "Content Theme",
    content_theme_desc: "AI-Generated Content Theme",
    auto_editing: "Auto-Editing",
    auto_editing_desc: "Intelligent Video Editing",
    auto_generation: "Auto-Generation",
    auto_generation_desc: "AI-Generated Video Content",
    platform_distribution: "Platform Distribution",
    platform_distribution_desc: "Multi-Platform Intelligent Distribution",
    result_analysis: "Result Analysis",
    result_analysis_desc: "Distribution Effect Analysis",
    video_revenue_analysis: "Video Revenue Statistics",
    smart_flow_status: "Smart Flow Status Monitoring",
    communication_protocol: "Communication Protocol",
    mcp_protocol: "MCP Protocol",
    http_interface: "HTTP Interface",
    real_time_communication: "Real-Time Communication",
    // StreamerWorkbench page related
    streamer_workbench: "Streamer Workbench",
    streamer_workbench_desc: "Professional Streamer Training, Live Script, and Highlight Moment Management",
    streamer_workbench_running: "Streamer Workbench Running",
    new_streamer: "New Streamer",
    total_streamers: "Total Streamers",
    online_streamers: "Online Streamers",
    online_rate: "Online Rate",
    today_training: "Today's Training",
    completion_rate: "Completion Rate",
    highlight_moments_count: "Highlight Moments",
    pre_broadcast_training_title: "Pre-Broadcast Training",
    basic_skill_training: "Basic Skill Training",
    basic_skill_desc: "Camera Operation, Lighting Adjustment, Sound Settings",
    script_training: "Script Training",
    script_training_desc: "Opening Lines, Interaction Techniques, Closing Lines",
    platform_rules: "Platform Rules Learning",
    platform_rules_desc: "Various Platform Live Streaming Regulations, Violation Behaviors",
    live_script_title: "Live Script",
    new_script: "New Script",
    opening_script: "Opening Script",
    opening_script_text: "Hello everyone, welcome to my live broadcast room...",
    interaction_script: "Interaction Script",
    interaction_script_text: "Thank you for your gifts, thank you for your support...",
    ending_script: "Ending Script",
    ending_script_text: "This live broadcast is over for today, see you tomorrow...",
    usage_count: "Usage Count",
    highlight_moments_title: "Highlight Moments",
    ai_recognition: "AI Recognition",
    wonderful_interaction: "Wonderful Interaction",
    wonderful_interaction_desc: "Exciting interaction moments with fans",
    talent_show: "Talent Show",
    talent_show_desc: "Exciting moments of streamer talent performance",
    funny_moment: "Funny Moment",
    funny_moment_desc: "Funny and interesting moments during live broadcasts",
    duration: "Duration",
    streamer_management: "Streamer Management",
    search_streamer: "Search Streamers...",
    streamer_status: "Status",
    training_progress: "Training Progress",
    highlight_count: "Highlight Count",
    online_live: "Online Live",
    training_in_progress: "Training in Progress",
    view: "View",
    // OperationWorkbench page related
    operation_workbench: "Operation Workbench",
    operation_workbench_desc: "Operation Management, Training Guidance, Data Analysis, Revenue Optimization",
    operation_workbench_running: "Operation Workbench Running",
    new_operation_task: "New Operation Task",
    operation_tasks: "Operation Tasks",
    training_completed: "Training Completed",
    auto_follow_count: "Auto-Follow",
    ai_driven: "AI Driven",
    revenue_growth: "Revenue Growth",
    this_month: "This Month",
    pre_broadcast_prep_title: "Pre-Broadcast Preparation",
    device_check: "Device Check",
    device_check_desc: "Camera, Microphone, Network Connection Check",
    scene_setup: "Scene Setup",
    scene_setup_desc: "Background Settings, Lighting Adjustment, Props Preparation",
    content_planning: "Content Planning",
    content_planning_desc: "Live Theme, Interaction Segments, Time Arrangement",
    creator_training_title: "Creator Training",
    new_training: "New Training",
    skill_training: "Skill Training",
    skill_training_desc: "Live Techniques, Interaction Methods, Script Training",
    platform_rules_training: "Platform Rules",
    platform_rules_training_desc: "Various Platform Regulations, Violation Behaviors, Best Practices",
    data_analysis_training: "Data Analysis",
    data_analysis_training_desc: "Data Interpretation, Trend Analysis, Optimization Suggestions",
    participants: "Participants",
    completed_count: "Completed Count",
    auto_follow_title: "Auto-Follow",
    hot_topics: "Hot Topics",
    hot_topics_desc: "Real-Time Monitoring of Hot Topics, Automatic Content Generation",
    competitor_analysis: "Competitor Analysis",
    competitor_analysis_desc: "Monitoring Competitor Dynamics, Analyzing Successful Strategies",
    content_recommendation: "Content Recommendation",
    content_recommendation_desc: "Content Related to Algorithm Recommendations",
    tracking_topics: "Tracking Topics",
    analysis_objects: "Analysis Objects",
    recommended_content: "Recommended Content",
    review_analysis_title: "Review Analysis",
    deep_analysis: "Deep Analysis",
    data_review: "Data Review",
    data_review_desc: "Viewing Data, Interaction Data, Revenue Analysis",
    problem_identification: "Problem Identification",
    problem_identification_desc: "Identifying Problems and Improvement Points in Live Broadcasting",
    optimization_suggestions: "Optimization Suggestions",
    optimization_suggestions_desc: "Optimization Suggestions Generated Based on Analysis",
    analysis_sessions: "Analysis Sessions",
    problems_found: "Problems Found",
    suggestions_count: "Suggestion Count",
    operation_task_management: "Operation Task Management",
    //all_status: "All Status",
    in_progress: "In Progress",
    completed: "Completed",
    pending: "Pending",
    filter: "Filter",
    task_name: "Task Name",
    task_type: "Type",
    task_status: "Status",
    progress: "Progress",
    training_task: "Training Task",
    follow_task: "Follow Task",
    new_streamer_training: "New Streamer Training Plan",
    new_streamer_training_desc: "Training New Streamers",
    hot_topic_follow: "Hot Topic Follow",
    hot_topic_follow_desc: "Following Hot Topics and Producing Content",
    //start: "Start",
    // VideoWorkbench page related
    video_workbench: "Video Workbench",
    video_workbench_desc: "Intelligent Video Production, Auto-Editing, Multi-Platform Distribution",
    video_workbench_running: "Video Workbench Running",
    new_video_project: "New Video Project",
    material_library: "Material Library",
    auto_editing_count: "Auto-Editing",
    platform_distribution_count: "Platform Distribution",
    multi_platform: "Multi-Platform",
    play_count: "Play Count",
    this_week: "This Week",
    material_management_title: "Material Management",
    upload_material: "Upload Material",
    live_recording: "Live Recording",
    live_recording_desc: "Material of Today's Live Broadcast Exciting Moments",
    background_music: "Background Music",
    background_music_desc: "Copyright Music Library, Sound Effects",
    effect_templates: "Effect Templates",
    effect_templates_desc: "Transitions, Filters, Animations",
    file_count: "File Count",
    content_theme_title: "Content Theme",
    hot_topic_theme: "Hot Topic Theme",
    hot_topic_theme_desc: "Content Theme Generated Based on Hot Search",
    emotional_resonance: "Emotional Resonance",
    emotional_resonance_desc: "Content Theme Causing Emotional Resonance",
    knowledge_sharing: "Knowledge Sharing",
    knowledge_sharing_desc: "Educational, Skill Sharing Themes",
    heat: "Heat",
    resonance_degree: "Resonance Degree",
    educational_value: "Educational Value",
    auto_editing_title: "Auto-Editing",
    smart_segmentation: "Smart Segmentation",
    smart_segmentation_desc: "AI Automatically Identifies Exciting Moments and Segments",
    auto_music: "Auto-Music",
    auto_music_desc: "Automatically Matches Background Music Based on Content",
    effect_addition: "Effect Addition",
    effect_addition_desc: "Automatically Adds Transitions, Filters, Subtitles",
    processing: "Processing",
    completed_videos: "Completed",
    queue: "Queue",
    auto_generation_title: "Auto-Generation",
    ai_creation: "AI Creation",
    title_generation: "Title Generation",
    title_generation_desc: "AI Generates Attractive Video Titles",
    subtitle_generation: "Subtitle Generation",
    subtitle_generation_desc: "Voice Recognition Automatically Generates Subtitles",
    cover_generation: "Cover Generation",
    cover_generation_desc: "AI Generates Video Cover Images",
    generating: "Generating",
    platform_distribution_title: "Platform Distribution",
    new_distribution_task: "New Distribution Task",
    douyin: "Douyin",
    kuaishou: "Kuaishou",
    video_account: "Video Account",
    short_video_distribution: "Short Video Platform Distribution",
    wechat_video_distribution: "WeChat Video Account Distribution",
    result_analysis_title: "Result Analysis",
    generate_report: "Generate Report",
    last_7_days: "Last 7 Days",
    last_30_days: "Last 30 Days",
    last_90_days: "Last 90 Days",
    total_play_count: "Total Play Count",
    new_fans_count: "New Fans",
    //completion_rate: "Completion Rate",
    revenue_analysis_amount: "Revenue Analysis",
    // 通用词汇
    requests: "Requests",
    goals: "Goals",
    tasks: "Tasks",
    results: "Results",
    //status: "状态",
    //active_status: "活跃",
    //processing_requests: "处理中",
    //decomposed_goals: "已拆解",
    //assigned_tasks: "已分配",
    //distributed_tasks: "已分发",
    //processed_results: "已处理"
    // CreatorLead页面相关
    creator_lead_dashboard: "Creator Lead Dashboard",
    new_leads_added: "new leads",
    added_to_talent_pool: "added to your talent pool this week. Keep it going!",
    leads: "Leads",
    rising: "Rising",
    affiliated: "Affiliated",
    eliminated: "Eliminated",
    live_creator: "LIVE creator",
    videos: "Videos",
    followers: "Followers",
    likes: "Likes",
    view_details: "View details",
    
    // CreatorDetail页面相关
    lead_added_on: "Lead added on: ",
    live_stream_data: "Live Stream Data",
    live_duration: "Live Duration",
    live_session_id: "Live Session",
    total_comments: "Total Comments",
    unique_commenters: "Unique Commenters",
    live_viewers: "Live Viewers",
    gift_count: "Gift Count",
    gift_value: "Gift Value",
    performance_trend: "Performance Trend",
    // 线索管理页面
    clue_management: "Clue Management",
    clue_management_desc: "Manage creator leads with status updates and filtering",
    status_filter: "Status Filter",
    start_date: "Start Date",
    end_date: "End Date",
    total_leads: "Total Leads",
    pending_leads: "Pending",
    contracting_leads: "Contracting",
    signed_leads: "Signed", 
    eliminated_leads: "Eliminated",
    lead_list: "Lead List",
    social_account: "Social Account",
    create_time: "Create Time",
    change_status: "Change Status",
    view_detail: "View Detail",
    change_lead_status: "Change Lead Status",
    lead_id: "Lead ID",
    new_status: "New Status",
    confirm_update: "Confirm Update",
    updating: "Updating...",
    status_update_success: "Status updated successfully",
    status_update_failed: "Status update failed, please try again",
    loading_data: "Loading...",
    load_failed: "Failed to load data, please try again",
    retry: "Retry",
    showing_records: "Showing",
    to: "to",
    of: "of",
    records: "records",
    previous_page: "Previous",
    next_page: "Next",
    follow_priority: "Follow Priority",
    change_priority: "Change Priority",
    change_lead_priority: "Change Lead Priority",
    new_priority: "New Priority",
    priority_update_success: "Priority updated successfully",
    priority_update_failed: "Priority update failed, please try again",
    
    // AgentChat页面相关
    agent_chat: "Agent Chat",
    agent_chat_desc: "Real-time conversation with agents for professional advice and solutions",
    agent_online: "Agent Online",
    clear_chat: "Clear Chat",
    available_agents: "Available Agents",
    select_agent: "Please Select Agent",
    select_agent_desc: "Select an agent to start conversation",
    welcome_message: "Welcome to Agent Chat System",
    welcome_desc: "Select an agent to begin your intelligent conversation journey",
    type_message: "Type your question...",
    send: "Send",
    
    // 招聘智能体页面相关
    recruitment_agent: "Recruitment Agent",
    recruitment_agent_desc: "Intelligent recruitment management system with embedded external recruitment system",
    system_online: "System Online",
    refresh: "Refresh",
    total_candidates: "Total Candidates",
    active_candidates: "Active Candidates",
    pending_reviews: "Pending Reviews",
    recruitment_success_rate: "Success Rate",
    recruitment_system: "Recruitment System",
    open_in_new_tab: "Open in New Tab",
    loading_system: "Loading system...",
    
    // 创作者视频相关
    creator_videos: "Creator Videos",
    total_videos: "Total Videos",
    total_views: "Total Views",
    loading_videos: "Loading videos...",
    click_video_to_watch: "Click video to watch",
    
    // 菜单名称
    menu_head_agent: "Head Agent",
    menu_head_flow: "Head Flow",
    menu_agent_chat: "Agent Chat",
    menu_recruitment_agent: "Recruitment Agent",
    menu_recruitment_management: "Recruitment Management",
    menu_external_system: "External System",
    menu_connect_agent: "Connect Agent",
    menu_connect_workbench: "Connect Workbench",
    menu_connect_flow: "Connect Flow",
    menu_streamer_agent: "Streamer Agent",
    menu_streamer_workbench: "Streamer Workbench",
    menu_streamer_flow: "Streamer Flow",
    menu_operation_agent: "Operation Agent",
    menu_operation_workbench: "Operation Workbench",
    menu_operation_flow: "Operation Flow",
    menu_publish_agent: "Publish Agent",
    menu_publish_workbench: "Publish Workbench",
    menu_publish_flow: "Publish Flow",
    
    // 页脚相关
    footer_description: "Entertainment live streaming intelligent workbench, providing comprehensive intelligent solutions for the live streaming industry",
    footer_products: "Products & Services",
    footer_smart_live_assistant: "Smart Live Assistant",
    footer_data_analysis: "Data Analysis Platform",
    footer_content_management: "Content Management System",
    footer_fan_interaction: "Fan Interaction Tools",
    footer_contact: "Contact Us",
    footer_phone: "400-888-8888",
    footer_email: "contact@withflows.ai",
    footer_address: "Room 201E, Building 2, Huigu Entrepreneurship Park, No. 33 Leshan Road, Xuhui District, Shanghai",
    footer_copyright: "© 2025 Withflows. All rights reserved.",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",
    
    // 招聘简历相关
    resume_list: "Resume List",
    resume_id: "Resume ID",
    candidate_name: "Candidate Name",
    position: "Position",
    experience: "Experience",
    submit_time: "Submit Time",
    pending_screening: "Pending Screening",
    interview: "Interview",
    rejected_status: "Rejected",
    hired_status: "Hired",
    resume_search_placeholder: "Search candidate name or position",
    update_resume_status: "Update Resume Status",
    resume_new_status: "New Status",
    resume_view: "View",
    resume_file: "Resume File",
    download: "Download",
    no_file: "No File",
    years: "years"
  },
  ja: {
    platformname: "Withflows",
    slogon: "オペレーションをよりスマートに",
    welcome: "おかえりなさい、張マネージャー",
    today: "今日は{date}です、お疲れ様です！",
    dashboard: "ダッシュボード",
    streamer_manage: "ストリーマー管理",
    add_streamer: "ストリーマー追加",
    search: "検索",
    status: "ステータス",
    level: "レベル",
    fans: "ファン数",
    income: "月収",
    live_hours: "配信時間",
    actions: "操作",
    edit: "編集",
    data: "データ",
    more: "詳細",
    online: "オンライン",
    offline: "オフライン",
    all: "すべて",
    active: "アクティブ",
    inactive: "非アクティブ",
    streamer_unit: "人のストリーマー",
    active_streamers: "アクティブストリーマー",
    income_today: "今日の収入",
    live_sessions: "配信セッション",
    new_fans: "新規ファン",
    ai_recommend: "AIスマート推奨",
    ai_recommend_desc: "AIがデータを自動分析し、運営提案とリスク警告をプッシュ",
    view_recommend: "推奨を表示",
    ai_schedule: "スマートスケジュール",
    ai_schedule_desc: "AIがストリーマーのパフォーマンスと視聴者好みに基づいて配信/イベントスケジュールを生成",
    schedule_now: "今すぐスケジュール",
    one_click_publish: "ワンクリック配信",
    one_click_publish_desc: "複数プラットフォームへのワンクリックコンテンツ配信をサポート、自動プラットフォーム適応",
    go_publish: "配信へ",
    streamer_manage_desc: "ストリーマー情報、契約、パフォーマンスなどのコアデータを管理",
    live_manage: "ライブ管理",
    live_manage_desc: "ライブデータ、インタラクション、ギフト統計などを監視",
    live_unit: "件のライブ中",
    content_ops: "コンテンツ運営",
    content_ops_desc: "コンテンツ企画、イベント企画、ファンインタラクションなど",
    activity_unit: "件のイベント進行中",
    finance_manage: "財務管理",
    finance_manage_desc: "収入統計、支出管理、利益分配決済など",
    this_month_income: "今月の収入",
    ai_assistant: "AIアシスタント",
    ai_assistant_desc: "AI運営提案、データ予測、スマートスケジュールなど",
    new_suggestion: "件の新提案",
    data_analytics: "データ分析",
    data_analytics_desc: "深度データ分析、トレンド予測、レポートエクスポートなど",
    new_report: "件の新レポート",
    ai_helper: "AIヘルパー",
    streamer_agent: "ストリーマーワークベンチ",
    operation_agent: "運営エージェントワークベンチ",
    publish_agent: "動画配信者ワークベンチ",
    add_task: "タスク追加",
    task_list: "タスクリスト",
    performance: "パフォーマンス概要",
    schedule: "スケジュール",
    notice: "お知らせ",
    role_connect_agent: "接続エージェント",
    role_streamer_agent: "ストリーマー",
    role_operation_agent: "運営エージェント",
    role_publish_agent: "動画配信者",
    save: "保存",
    cancel: "キャンセル",
    search_placeholder: "キーワードを入力...",
    connect_agent: "接続エージェント",
    account_assign: "アカウント割り当て",
    add_account: "新規アカウント",
    account_assign_desc: "バッチインポートとAIスマート割り当てをサポートするプラットフォームアカウントの割り当て",
    ai_assign: "AIスマート割り当て",
    clue_pool: "リードプール/フロー",
    clue_flow: "リードフロー",
    clue_desc: "AIリード優先度ソートとフロー提案をサポートするリードプールの管理",
    ai_clue: "AIリード分析",
    contact: "コミュニケーション＆連絡",
    add_contact: "新規コミュニケーション",
    contact_desc: "AI自動生成スクリプトとレコードによるストリーマー/クライアントとのコミュニケーション",
    ai_contact: "AIスクリプト推奨",
    convert: "コンバージョン＆契約",
    add_contract: "新規契約",
    convert_desc: "AIコンバージョン率予測と契約提案によるコンバージョンフォローアップ",
    ai_convert: "AIコンバージョン予測",
    all_status: "すべてのステータス",
    status_live: "配信中",
    status_rest: "休憩中",
    status_pending: "審査待ち",
    // StreamerAgentページ関連
    prepare: "配信準備",
    add_prepare: "準備追加",
    prepare_desc: "設備チェック、コンテンツ準備、スケジュール調整などの配信前準備を管理",
    ai_prepare: "AIスマート準備",
    device_purchase: "設備/ソフトウェア購入",
    add_device: "設備追加",
    device_desc: "カメラ、マイク、配信ソフトウェアなどのライブ配信設備とソフトウェア購入を管理",
    ai_device: "AI設備推奨",
    test: "配信テスト/試行",
    start_test: "テスト開始",
    test_desc: "設備とコンテンツが正常に動作することを確認するためのライブ配信テストと試行を実施",
    ai_test: "AIテスト提案",
    start: "正式配信",
    go_live: "配信開始",
    start_desc: "正式にライブ配信を開始し、配信中の様々な側面を管理",
    ai_live: "AI配信アシスタント",
    // OperationAgentページ関連
    train: "トレーニング/評価/コーチング",
    add_train: "トレーニング追加",
    train_desc: "配信テクニック、コンテンツ作成、ファンインタラクションなどのストリーマートレーニングとスキル向上",
    ai_train: "AIトレーニング提案",
    report: "データレポート/分析/振り返り",
    add_report: "レポート追加",
    report_desc: "配信データ、ファン増加、収入統計などのデータ分析とレポート生成",
    ai_report: "AIレポート生成",
    income_calc: "収益計算",
    calc_income: "収益計算",
    income_desc: "収入統計、支出管理、利益分配決済などの収益計算と財務管理",
    ai_income: "AI収益予測",
    customer_binding: "顧客バインディング管理",
    // PublishAgentページ関連
    material: "素材ライブラリ/テンプレート/デザイン",
    add_material: "素材追加",
    material_desc: "画像、動画、音声などの動画素材とテンプレートを管理",
    ai_material: "AI素材推奨",
    clip: "動画クリップ/字幕/翻訳",
    add_clip: "クリップ追加",
    clip_desc: "動画分割、字幕追加、多言語翻訳などの動画編集と字幕処理",
    ai_clip: "AIスマート編集",
    publish: "マルチプラットフォーム配信",
    add_publish: "配信追加",
    publish_desc: "複数プラットフォームへのワンクリック配信をサポートするマルチプラットフォームコンテンツ配信管理",
    ai_publish: "AIスマート配信",
    // HeadAgent page related
    head_agent: "Head-Agent 総合智能体",
    head_agent_desc: "中央協調器 - 意図認識、目標分解、Agent分発、結果処理",
    running: "運行中",
    config: "設定",
    workflow_status: "ワークフロー状態",
    intent_recognition: "意図認識",
    intent_recognition_desc: "ユーザーの要望を理解",
    active_status: "アクティブ",
    processing_requests: "処理中",
    goal_decomposition: "目標分解",
    goal_decomposition_desc: "複雑なタスクを分解",
    decomposed_goals: "分解済み",
    agent_decomposition: "Agent分解",
    agent_decomposition_desc: "専門的なAgentを分配",
    assigned_tasks: "割り当て済み",
    agent_distribution: "Agent分発",
    agent_distribution_desc: "タスクを分発実行",
    distributed_tasks: "分発済み",
    result_processing: "結果処理",
    result_processing_desc: "結果をまとめて処理",
    processed_results: "処理済み",
    input_monitoring: "入力源監視",
    anchor_elf_input: "アンカーイルフ入力",
    dialogue_request: "ダイアログリクエスト",
    observation_data: "観察データ",
    suggestion_generation: "提案生成",
    pan_entertainment_input: "パンエンタメンタリティプラグインAgent入力",
    speech_generation: "スピーチ生成",
    data_analysis: "データ分析",
    auto_follow: "自動フォロー",
    output_monitoring: "出力目標監視",
    frontend_output: "フロントエンドプラットフォーム出力",
    backend_output: "バックエンドサービス出力",
    data_storage: "データストレージ",
    api_call: "API呼び出し",
    log_record: "ログ記録",
    success: "成功",
    real_time_monitoring: "リアルタイム監視パネル",
    today_requests: "今日の処理リクエスト",
    success_rate: "成功率",
    avg_response_time: "平均応答時間",
    active_agents: "アクティブAgent",
    // TotalFlow page related
    total_flow: "総合智能流",
    total_flow_desc: "各専門Agentを調整する総合智能流",
    smart_flow_running: "智能流運行中",
    flow_config: "ワークフロー設定",
    head_agent_coordinator: "Head-Agent 中央協調器",
    smart_coordinating: "スマート協調中",
    understand_demand: "ユーザーの要望を理解",
    decompose_tasks: "複雑なタスクを分解",
    assign_agents: "専門Agentを分配",
    distribute_tasks: "タスクを分発実行",
    process_results: "結果をまとめて処理",
    professional_agents: "専門Agentワークフロー",
    recruiting_agent: "Recruiting-Agent 採用代理",
    creator_agent: "Creator-Agent クリエイター代理",
    //operation_agent: "Operation-Agent 運営代理",
    video_producer_agent: "VideoProducer-Agent ビデオ制作代理",
    lead_collection: "リード収集",
    lead_collection_desc: "潜在クリエイター情報を自動収集",
    analysis: "分析",
    analysis_desc: "クリエイターの潜在力を分析",
    connection: "建連",
    connection_desc: "基本的な連絡を確立",
    recruitment_cooperation: "採用協力",
    recruitment_cooperation_desc: "合意を達成",
    pre_broadcast_training: "配信前受訓",
    pre_broadcast_training_desc: "専門的なトレーニングでスキル向上",
    live_script: "配信スクリプト",
    live_script_desc: "AIによる配信スクリプト生成",
    highlight_moments: "ハイライトモーメント",
    highlight_moments_desc: "AIによるハイライトモーメントの自動識別",
    review_improvement: "振り返り改善",
    review_improvement_desc: "データ分析による改善提案",
    revenue_summary: "収益概要",
    revenue_summary_desc: "収益統計と分析",
    pre_broadcast_prep: "配信前準備",
    pre_broadcast_prep_desc: "設備チェックとシーン設定",
    creator_training: "クリエイタートレーニング",
    creator_training_desc: "専門的なスキル向上",
    auto_follow_broadcast: "自動フォロー",
    auto_follow_broadcast_desc: "スマートフォロー",
    review: "振り返り",
    review_desc: "データ分析",
    revenue_analysis: "収益分析",
    revenue_analysis_desc: "収益トレンドと予測",
    material_management: "素材管理",
    material_management_desc: "素材分類整理",
    content_theme: "コンテンツテーマ",
    content_theme_desc: "AIによるコンテンツテーマ生成",
    auto_editing: "自動編集",
    auto_editing_desc: "AIによるビデオ編集",
    auto_generation: "自動生成",
    auto_generation_desc: "AIによるビデオコンテンツ生成",
    platform_distribution: "平台分发",
    platform_distribution_desc: "複数プラットフォームへのスマート分発",
    result_analysis: "結果分析",
    result_analysis_desc: "分発効果分析",
    video_revenue_analysis: "ビデオ収益統計",
    smart_flow_status: "スマートフロー状態監視",
    communication_protocol: "通信プロトコル",
    mcp_protocol: "MCPプロトコル",
    http_interface: "HTTPインターフェース",
    real_time_communication: "リアルタイム通信",
    // StreamerWorkbench page related
    streamer_workbench: "ストリーマー作業台",
    streamer_workbench_desc: "専門ストリーマートレーニング、配信スクリプト、ハイライトモーメント管理",
    streamer_workbench_running: "ストリーマー作業台運行中",
    new_streamer: "新規ストリーマー",
    total_streamers: "総ストリーマー数",
    online_streamers: "オンラインストリーマー",
    online_rate: "オンライン率",
    today_training: "今日のトレーニング",
    completion_rate: "完了率",
    highlight_moments_count: "ハイライトモーメント",
    pre_broadcast_training_title: "配信前受訓",
    basic_skill_training: "基本スキルトレーニング",
    basic_skill_desc: "カメラ操作、照明調整、音声設定",
    script_training: "スクリプトトレーニング",
    script_training_desc: "オープニング、インタラクション、クロージング",
    platform_rules: "プラットフォームルール学習",
    platform_rules_desc: "各プラットフォームの配信規範、違反行為",
    live_script_title: "配信スクリプト",
    new_script: "新規スクリプト",
    opening_script: "オープニングスクリプト",
    opening_script_text: "みなさん、こんにちは、ようこそ...",
    interaction_script: "インタラクションスクリプト",
    interaction_script_text: "ありがとうございます、ありがとうございます...",
    ending_script: "クロージングスクリプト",
    ending_script_text: "今日の配信はこれで終わります、またお会いしましょう...",
    usage_count: "使用次数",
    highlight_moments_title: "ハイライトモーメント",
    ai_recognition: "AI識別",
    wonderful_interaction: "素晴らしいインタラクション",
    wonderful_interaction_desc: "ファンとの素晴らしいインタラクション",
    talent_show: "才艺展示",
    talent_show_desc: "ストリーマーの才芸表演",
    funny_moment: "笑いの瞬間",
    funny_moment_desc: "配信中の笑いの瞬間",
    duration: "時間",
    streamer_management: "ストリーマー管理",
    search_streamer: "ストリーマーを検索...",
    streamer_status: "ステータス",
    training_progress: "トレーニング進行",
    highlight_count: "ハイライトモーメント",
    online_live: "オンライン配信",
    training_in_progress: "トレーニング中",
    view: "表示",
    // OperationWorkbench page related
    operation_workbench: "運営作業台",
    operation_workbench_desc: "運営管理、トレーニング指導、データ分析、収益最適化",
    operation_workbench_running: "運営作業台運行中",
    new_operation_task: "新規運営タスク",
    operation_tasks: "運営タスク",
    training_completed: "トレーニング完了",
    auto_follow_count: "自動フォロー",
    ai_driven: "AI駆動",
    revenue_growth: "収益増加",
    this_month: "今月",
    pre_broadcast_prep_title: "配信前準備",
    device_check: "設備チェック",
    device_check_desc: "カメラ、マイク、ネットワーク接続チェック",
    scene_setup: "シーン設定",
    scene_setup_desc: "背景設定、照明調整、道具準備",
    content_planning: "コンテンツ計画",
    content_planning_desc: "配信テーマ、インタラクション、時間計画",
    creator_training_title: "クリエイタートレーニング",
    new_training: "新規トレーニング",
    skill_training: "スキルトレーニング",
    skill_training_desc: "配信テクニック、インタラクション方法、スクリプトトレーニング",
    platform_rules_training: "プラットフォームルール",
    platform_rules_training_desc: "各プラットフォームの規範、違反行為、ベストプラクティス",
    data_analysis_training: "データ分析",
    data_analysis_training_desc: "データ解説、トレンド分析、最適化提案",
    participants: "参加人数",
    completed_count: "完了人数",
    auto_follow_title: "自動フォロー",
    hot_topics: "ホットトピック",
    hot_topics_desc: "リアルタイム監視ホットトピック、コンテンツ自動生成",
    competitor_analysis: "競合分析",
    competitor_analysis_desc: "競合動態監視、成功戦略分析",
    content_recommendation: "コンテンツ推薦",
    content_recommendation_desc: "アルゴリズムに基づく関連コンテンツ推薦",
    tracking_topics: "トラッキングトピック",
    analysis_objects: "分析対象",
    recommended_content: "推薦コンテンツ",
    review_analysis_title: "振り返り分析",
    deep_analysis: "深度分析",
    data_review: "データ振り返り",
    data_review_desc: "視聴データ、インタラクションデータ、収益分析",
    problem_identification: "問題識別",
    problem_identification_desc: "配信中の問題と改善点の識別",
    optimization_suggestions: "优化建议",
    optimization_suggestions_desc: "基于分析生成优化建议",
    analysis_sessions: "分析场次",
    problems_found: "問題発見",
    suggestions_count: "提案数",
    operation_task_management: "運営タスク管理",
    //all_status: "全部ステータス",
    in_progress: "進行中",
    completed: "完了",
    pending: "待開始",
    filter: "フィルター",
    task_name: "タスク名",
    task_type: "タスクタイプ",
    task_status: "ステータス",
    progress: "進行",
    training_task: "トレーニングタスク",
    follow_task: "フォロータスク",
    new_streamer_training: "新ストリーマートレーニング計画",
    new_streamer_training_desc: "新ストリーマーのトレーニング",
    hot_topic_follow: "ホットトピックフォロー",
    hot_topic_follow_desc: "ホットトピックを追跡してコンテンツを制作",
    // start: "开始",
    // VideoWorkbench page related
    video_workbench: "ビデオ作業台",
    video_workbench_desc: "スマートビデオ制作、自動編集、マルチプラットフォーム分発",
    video_workbench_running: "ビデオ作業台運行中",
    new_video_project: "新規ビデオプロジェクト",
    material_library: "素材ライブラリ",
    auto_editing_count: "自動編集",
    platform_distribution_count: "プラットフォーム分発",
    multi_platform: "マルチプラットフォーム",
    play_count: "再生数",
    this_week: "今週",
    material_management_title: "素材管理",
    upload_material: "アップロード素材",
    live_recording: "ライブ録画",
    live_recording_desc: "今日のライブのハイライトモーメント素材",
    background_music: "背景音楽",
    background_music_desc: "著作権音楽ライブラリ、効果素材",
    effect_templates: "効果テンプレート",
    effect_templates_desc: "トランジション、フィルター、アニメーション",
    file_count: "ファイル数",
    content_theme_title: "コンテンツテーマ",
    hot_topic_theme: "ホットトピック",
    hot_topic_theme_desc: "トレンドのコンテンツテーマ",
    emotional_resonance: "感情共鳴",
    emotional_resonance_desc: "感情共鳴のコンテンツテーマ",
    knowledge_sharing: "知識共有",
    knowledge_sharing_desc: "教育系、技能共有テーマ",
    heat: "人気度",
    resonance_degree: "共鳴度",
    educational_value: "教育価値",
    auto_editing_title: "自動編集",
    smart_segmentation: "智能分段",
    smart_segmentation_desc: "AIによるハイライトモーメントの自動分段",
    auto_music: "自動配楽",
    auto_music_desc: "コンテンツに合わせて自動的に背景音楽を選択",
    effect_addition: "効果追加",
    effect_addition_desc: "トランジション、フィルター、字幕の自動追加",
    processing: "処理中",
    completed_videos: "完了ビデオ",
    queue: "キュー",
    //auto_generation_title: "自動生成",
    auto_generation_title: "自動生成",
    ai_creation: "AIクリエイティブ",
    title_generation: "タイトル生成",
    title_generation_desc: "AIによるビデオタイトル生成",
    subtitle_generation: "字幕生成",
    subtitle_generation_desc: "音声認識による字幕自動生成",
    cover_generation: "カバー生成",
    cover_generation_desc: "AIによるビデオカバー画像生成",
    generating: "生成中",
    platform_distribution_title: "プラットフォーム分発",
    new_distribution_task: "新規分発タスク",
    douyin: "ドウイン",
    kuaishou: "クアイシュー",
    video_account: "ビデオアカウント",
    short_video_distribution: "短編ビデオプラットフォーム分発",
    wechat_video_distribution: "ウェチャットビデオアカウント分発",
    result_analysis_title: "結果分析",
    generate_report: "レポート生成",
    last_7_days: "最近7日",
    last_30_days: "最近30日",
    last_90_days: "最近90日",
    total_play_count: "総再生数",
    new_fans_count: "新規ファン",
    //completion_rate: "完播率",
    revenue_analysis_amount: "収益分析額",
    // 通用词汇
    requests: "個リクエスト",
    goals: "個目標",
    tasks: "個タスク",
    results: "個結果",
    //status: "状态",
    //active_status: "活跃",
    //processing_requests: "处理中",
    //decomposed_goals: "已拆解",
    //assigned_tasks: "已分配",
    //distributed_tasks: "已分发",
    //processed_results: "已处理"
    // CreatorLead页面相关
    creator_lead_dashboard: "创作者线索仪表盘",
    new_leads_added: "新增线索",
    added_to_talent_pool: "已添加到人才库，继续努力！",
    leads: "线索",
    rising: "上升中",
    affiliated: "已关联",
    eliminated: "已淘汰",
    live_creator: "直播创作者",
    videos: "视频",
    followers: "粉丝",
    likes: "点赞",
    view_details: "查看详情",
    
    // CreatorDetail页面相关
    lead_added_on: "线索添加时间：",
    live_stream_data: "直播数据",
    live_duration: "直播时长",
    live_session_id: "直播场次",
    total_comments: "总评论",
    unique_commenters: "评论者人数",
    live_viewers: "直播观众",
    gift_count: "礼物数量",
    gift_value: "礼物价值",
    performance_trend: "绩效趋势",
    // 线索管理页面
    clue_management: "线索池管理",
    clue_management_desc: "管理创作者线索，支持状态变更和筛选查询",
    status_filter: "状态筛选",
    start_date: "开始日期",
    end_date: "结束日期",
    total_leads: "总线索",
    pending_leads: "待处理",
    contracting_leads: "预跟踪",
    signed_leads: "已签约",
    eliminated_leads: "已淘汰",
    lead_list: "线索列表",
    social_account: "社交账号",
    create_time: "创建时间",
    change_status: "变更状态",
    view_detail: "查看详情",
    change_lead_status: "变更线索状态",
    lead_id: "线索ID",
    new_status: "新状态",
    confirm_update: "确认更新",
    updating: "更新中...",
    status_update_success: "状态更新成功",
    status_update_failed: "状态更新失败，请重试",
    loading_data: "加载中...",
    load_failed: "加载数据失败，请重试",
    retry: "重试",
    showing_records: "显示第",
    to: "到",
    of: "条，共",
    records: "条记录",
    previous_page: "上一页",
    next_page: "下一页",
    follow_priority: "フォロー優先度",
    change_priority: "優先度変更",
    change_lead_priority: "リード優先度の変更",
    new_priority: "新しい優先度",
    priority_update_success: "優先度が正常に更新されました",
    priority_update_failed: "優先度の更新に失敗しました。再試行してください",
    
    // AgentChat页面相关
    agent_chat: "エージェントチャット",
    agent_chat_desc: "エージェントとのリアルタイム会話で専門的なアドバイスとソリューションを取得",
    agent_online: "エージェントオンライン",
    clear_chat: "チャットクリア",
    available_agents: "利用可能なエージェント",
    select_agent: "エージェントを選択してください",
    select_agent_desc: "会話を開始するエージェントを選択",
    welcome_message: "エージェントチャットシステムへようこそ",
    welcome_desc: "エージェントを選択してインテリジェントな会話の旅を始めましょう",
    type_message: "質問を入力...",
    send: "送信",
    
    // 招聘智能体页面相关
    recruitment_agent: "採用エージェント",
    recruitment_agent_desc: "外部採用システムを埋め込んだインテリジェント採用管理システム",
    system_online: "システムオンライン",
    refresh: "更新",
    total_candidates: "総候補者",
    active_candidates: "アクティブ候補者",
    pending_reviews: "審査待ち",
    recruitment_success_rate: "成功率",
    recruitment_system: "採用システム",
    open_in_new_tab: "新しいタブで開く",
    loading_system: "システム読み込み中...",
    
    // 创作者视频相关
    creator_videos: "クリエイタービデオ",
    total_videos: "総ビデオ数",
    total_views: "総再生数",
    loading_videos: "ビデオ読み込み中...",
    click_video_to_watch: "ビデオをクリックして視聴",
    
    // 菜单名称
    menu_head_agent: "ヘッドエージェント",
    menu_head_flow: "ヘッドフロー",
    menu_agent_chat: "エージェントチャット",
    menu_recruitment_agent: "採用エージェント",
    menu_recruitment_management: "採用管理",
    menu_external_system: "外部システム",
    menu_connect_agent: "接続エージェント",
    menu_connect_workbench: "接続ワークベンチ",
    menu_connect_flow: "接続フロー",
    menu_streamer_agent: "ストリーマーエージェント",
    menu_streamer_workbench: "ストリーマーワークベンチ",
    menu_streamer_flow: "ストリーマーフロー",
    menu_operation_agent: "運営エージェント",
    menu_operation_workbench: "運営ワークベンチ",
    menu_operation_flow: "運営フロー",
    menu_publish_agent: "配信エージェント",
    menu_publish_workbench: "配信ワークベンチ",
    menu_publish_flow: "配信フロー",
    
    // 页脚相关
    footer_description: "エンターテイメントライブストリーミングインテリジェントワークベンチ、ライブストリーミング業界に包括的なインテリジェントソリューションを提供",
    footer_products: "製品・サービス",
    footer_smart_live_assistant: "スマートライブアシスタント",
    footer_data_analysis: "データ分析プラットフォーム",
    footer_content_management: "コンテンツ管理システム",
    footer_fan_interaction: "ファンインタラクションツール",
    footer_contact: "お問い合わせ",
    footer_phone: "400-888-8888",
    footer_email: "contact@withflows.ai",
    footer_address: "上海市徐汇区乐山路33号慧谷创业园2号楼201E",
    footer_copyright: "© 2025 Withflows. All rights reserved.",
    footer_privacy: "プライバシーポリシー",
    footer_terms: "利用規約",
    
    // 招聘简历相关
    resume_list: "履歴書リスト",
    resume_id: "履歴書ID",
    candidate_name: "候補者名",
    position: "応募職位",
    experience: "経験",
    submit_time: "提出時間",
    pending_screening: "選考中",
    interview: "面接",
    rejected_status: "拒否",
    hired_status: "採用",
    resume_search_placeholder: "候補者名または職位で検索",
    update_resume_status: "履歴書ステータス更新",
    resume_new_status: "新しいステータス",
    resume_view: "表示",
    resume_file: "履歴書ファイル",
    download: "ダウンロード",
    no_file: "ファイルなし",
    years: "年"
  }
}

export function getText(key, lang = 'zh') {
  return i18n[lang]?.[key] || key
}

export function formatText(text, params = {}, lang = 'zh') {
  let result = getText(text, lang)
  Object.keys(params).forEach(key => {
    result = result.replace(`{${key}}`, params[key])
  })
  return result
} 